//LIBRARIES
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Auth from 'j-toker';
import FlatButton from 'material-ui/FlatButton';
import scrollIntoView from 'scroll-into-view';

import {
  MdAccountBox as IdentityIcon,
  MdPeople as PersonalReferenceIcon,
  MdLocalAtm as IncomeIcon,
  MdLocationCity as HomeIcon,
  MdBusiness as WorkIcon,
  MdGroupAdd as LandlordReferenceIcon,
} from 'react-icons/md';

//HELPERS
import Checkbox from 'helpers/reduxFormMaterialUiNext/Checkbox';
import { titleize } from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const style = {
  button: {
    color: 'white',
    height: '40px',
  },
  itemBox: {
    textAlign: 'center',
    width: '200px',
    height: '100px',
  },
  details: {
    fontFamily: 'Circular',
    textAlign: 'center',
  },
  emphasis: {
    fontFamily: 'Circular-Black',
  },
};

let WizardFormIntroPage = (props) => {
  const { handleSubmit, hasApplicationFee } = props;
  return (
    <div style={{ marginTop: '50px' }}>
      <div>
        <h3
          style={{
            fontSize: '30px',
            marginBottom: '20px',
            fontFamily: 'Circular-Bold',
            textAlign: 'center',
          }}
        >
          {getTranslatedString('tenantPortal.application.welcomeMessage.title', {
            name: titleize(Auth.user.first_name),
          })}{' '}
        </h3>
        {hasApplicationFee ? (
          <h4 style={style.details}>
            <b style={style.emphasis}>
              {' '}
              {getTranslatedString('tenantPortal.application.welcome.feeNote')}{' '}
            </b>
            {getTranslatedString('tenantPortal.application.welcome.feeNoteWarning')}
          </h4>
        ) : (
          <h4 style={style.details}>
            <b style={style.emphasis}>
              {getTranslatedString('tenantPortal.application.welcome.tip')}{' '}
            </b>
            {getTranslatedString('tenantPortal.application.welcome.tipInfo')}
          </h4>
        )}
        <h4 style={{ textAlign: 'center', margin: '35px 0 15px 0', fontFamily: 'Circular-Bold' }}>
          {getTranslatedString('tenantPortal.application.welcome.informationWarning')}
        </h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="application-selection-grid">
          <div style={{ textAlign: 'center' }}>
            <div className="row">
              <HomeIcon
                style={{
                  fontSize: '85px',
                  color: '#4e4e4e',
                  marginBottom: '-10px',
                }}
              />
            </div>
            <Field name="hasCurrentAddress" component={Checkbox} />
            <p style={{ fontSize: '16px', margin: '-8px 0 0' }}>
              {' '}
              {getTranslatedString('tenantPortal.application.welcome.informationAddress')}
            </p>
            <p>
              {' '}
              {getTranslatedString('tenantPortal.application.welcome.informationWhereYouLive')}
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div className="row">
              <WorkIcon
                style={{
                  fontSize: '85px',
                  color: '#4e4e4e',
                  marginBottom: '-10px',
                }}
              />
            </div>
            <Field name="hasCurrentOccupation" component={Checkbox} />
            <p style={{ fontSize: '16px', margin: '-8px 0 0' }}>
              {getTranslatedString('tenantPortal.application.welcome.informationOccupation')}{' '}
            </p>
            <p>{getTranslatedString('addressAndIncome')}</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div className="row">
              <PersonalReferenceIcon
                style={{
                  fontSize: '85px',
                  color: '#4e4e4e',
                  marginBottom: '-10px',
                }}
              />
            </div>
            <Field name="hasPersonalReference" component={Checkbox} />
            <p style={{ fontSize: '16px', margin: '-8px 0 0' }}>
              {getTranslatedString('tenantPortal.application.welcome.informationReference')}
            </p>
            <p>
              {getTranslatedString('tenantPortal.application.welcome.informationReferenceInfo')}
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div className="row">
              <LandlordReferenceIcon
                style={{
                  fontSize: '85px',
                  color: '#4e4e4e',
                  marginBottom: '-10px',
                }}
              />
            </div>
            <Field
              name="hasLandlordReference"
              component={Checkbox}
              label={getTranslatedString('tenantPortal.application.welcome.referenceLabel')}
            />
            <p style={{ fontSize: '16px', margin: '-8px 0 0' }}>
              {getTranslatedString('tenantPortal.application.welcome.landlordReference')}
            </p>
            <p>
              {getTranslatedString('tenantPortal.application.welcome.landlordReferenceWarning')}
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div className="row">
              <IncomeIcon
                style={{
                  fontSize: '85px',
                  color: '#4e4e4e',
                  marginBottom: '-10px',
                }}
              />
            </div>
            <Field name="hasProofOfIncome" component={Checkbox} />
            <p style={{ fontSize: '16px', margin: '-8px 0 0' }}>
              {getTranslatedString('tenantPortal.application.welcome.income')}
            </p>
            <p> {getTranslatedString('tenantPortal.application.welcome.incomeProof')}</p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div className="row">
              <IdentityIcon
                style={{
                  fontSize: '85px',
                  color: '#4e4e4e',
                  marginBottom: '-10px',
                }}
              />
            </div>
            <Field
              name="hasIdentity"
              component={Checkbox}
              label={getTranslatedString('tenantPortal.application.welcome.incomeLabel')}
            />
            <p style={{ fontSize: '16px', margin: '-8px 0 0' }}>
              {getTranslatedString('tenantPortal.application.welcome.identity')}
            </p>
            <p> {getTranslatedString('tenantPortal.application.welcome.identityProof')}</p>
          </div>
          <div style={{ marginBottom: '40px' }} />
          <div id="application_footerbar">
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
              <FlatButton
                label={getTranslatedString('tenantPortal.application.welcome.button')}
                type="submit"
                className="next"
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                style={style.button}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

WizardFormIntroPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
    });
  },
})(WizardFormIntroPage);

export default WizardFormIntroPage;
